export const encoderSecureParams = (data) => {
    // Convertir el objeto a string y codificar en base64
    const base64 = btoa(JSON.stringify(data));
    
    // Añadir una capa adicional de ofuscación
    const timestamp = Date.now();
    const encoded = base64.split('').reverse().join('') + '.' + timestamp;
    
    // Codificar URL-safe
    return encodeURIComponent(encoded);
  };